"use client";

import { useEffect } from "react";
import type { Row, RowData } from "@tanstack/react-table";
import type { RecordGridFeatures } from "@/components/ui/record-table/grid/record-grid-features";
import { rememberRecordSequence } from "@/lib/navigation/record-sequence";
import type { RecordObjectDef } from "../types";

const HREF_SEPARATOR = "\n";

export function useRememberRecordSequence<TData extends RowData>(
  object: RecordObjectDef<TData>,
  rows: Row<RecordGridFeatures, TData>[],
) {
  const { getRowHref } = object;
  const joinedHrefs = getRowHref
    ? rows
        .map((row) => getRowHref(row.original))
        .filter((href): href is string => href !== undefined)
        .join(HREF_SEPARATOR)
    : "";

  useEffect(() => {
    if (joinedHrefs === "") return;
    rememberRecordSequence(
      object.id,
      window.location.pathname,
      joinedHrefs.split(HREF_SEPARATOR),
    );
  }, [joinedHrefs, object.id]);
}
